// extracted by mini-css-extract-plugin
module.exports = {"main":"Sidebar_main__1MCX5","open":"Sidebar_open__gnBQb"};